import {useState, useEffect} from 'react';
import {isIE11} from 'utils/platform';

export function useImagePreload(source: string) {
  const canPreload = !!source && !isIE11();
  const [image, setImage] = useState(!canPreload ? source : '');

  useEffect(() => {
    if (!canPreload)
      return () => {};
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'document';
    xhr.open('GET', source, true);
    xhr.onload = () => xhr.status === 200 && setImage(source);
    xhr.send();
    return () => {
      try {xhr.abort()} catch (e) {}
    }
  }, [source]);

  return image;
}
